<app-page-loader></app-page-loader>
<app-header *ngIf="!_router.url.includes('/authentication')" ></app-header>
<div class="container-fluid p-0 theme-bg py-3 py-md-5">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>